import type { BridgeAccount } from "../../shared/contracts";

export function accountSymbolStatus(account: BridgeAccount): { text: string; warning: boolean } {
  const target = account.symbolMap.XAUUSD ?? "XAUUSD";
  const prefix = `XAUUSD → ${target}`;
  const config = account.snapshot?.symbolConfiguration;
  if (!config) return { text: `${prefix} · EA 尚未回報商品檢查`, warning: false };
  if (!account.online) return { text: `${prefix} · 帳戶離線，等待 EA 確認`, warning: false };
  if (config.logicalSymbol !== "XAUUSD") {
    return { text: `${prefix} · EA 邏輯商品設定不一致（${config.logicalSymbol}）`, warning: true };
  }
  if (config.brokerSymbol !== target) {
    return { text: `${prefix} · 等待 EA 確認新設定`, warning: false };
  }
  if (!config.brokerSymbolAvailable) {
    return { text: `${prefix} · 商品設定錯誤：MT4 找不到此代號，請確認大小寫`, warning: true };
  }
  if (!account.snapshot?.terminal.connected) {
    return { text: `${prefix} · 等待 MT4 連線確認`, warning: false };
  }
  if (!config.defaultSymbolAvailable) {
    return { text: `${prefix} · 商品存在；EA 預設報價商品 ${config.defaultSymbol} 無效，請修正`, warning: true };
  }
  return { text: `${prefix} · EA 已確認商品存在`, warning: false };
}
